import { getDetail, isRedeem } from '@/api/store.js'
export default {
  data () {
    return { details: {} }
  },
  created () {
    this.getDetail()
  },
  methods: {
    async getDetail () {
      try {
        const { data } = await getDetail(this.$route.query.id)
        this.details = data
      } catch (e) {
        console.log(e, 'getDetail...')
      }
    },
    async handleVerify () {
      try {
        const { data } = await isRedeem({
          productId: this.form.productId,
          redeemNum: Number(this.form.redeemNum),
          redeemConsume: this.details.redeemPrice * this.form.redeemNum
        })
        return data
      } catch (e) {
        this.$message.error(e)
        return false
      }
    }
  }
}
